<template>
  <div class="d-flex f-size-14" :class="[{ 'overflow-auto': !isSearch }]">
    <div class="tier-filter d-flex my-auto">
      <div>
        <span>Tier: </span>
      </div>
      <div class="ml-4 my-auto">
        <b-form-checkbox-group
          v-model="filter.tier"
          :options="tierList"
          class="m-0 custom"
          value-field="id"
          text-field="name"
          disabled-field="notEnabled"
        ></b-form-checkbox-group>
      </div>
    </div>
    <div class="channel-filter d-flex my-auto ml-4 border-left pl-4">
      <div>
        <span>Channel: </span>
      </div>

      <div class="ml-4 my-auto">
        <b-form-checkbox-group
          v-model="filter.channel"
          :options="channelList"
          class="m-0"
          value-field="id"
          text-field="name"
          disabled-field="notEnabled"
        ></b-form-checkbox-group>
      </div>
    </div>
    <div class="search-intent-panel m-auto">
      <b-dropdown
        size="lg"
        variant="link"
        toggle-class="text-decoration-none"
        no-caret
        right
      >
        <template #button-content>
          <font-awesome-icon
            @click.prevent="isSearch = true"
            icon="search"
            class="icon mt-1 pointer text-black"
          />
        </template>

        <div>
          <b-input-group class="panel-intent-serach">
            <b-form-input
              id="product-search"
              class="input-serach"
              v-model="search"
              @keyup="handleSearch"
              placeholder="ค้นหาชื่ออินเทนต์, คีย์เวิร์ด"
            ></b-form-input>
            <b-input-group-prepend>
              <span class="icon-input m-auto pr-2">
                <font-awesome-icon
                  icon="search"
                  title="View"
                  @click="$emit('searchIntent', search)"
                />
              </span>
            </b-input-group-prepend>
          </b-input-group>
        </div>
      </b-dropdown>
    </div>
    <div class="language-filter d-flex my-auto ml-2 px-3">
      <b-button-group class="btn-language">
        <b-button
          :class="{ active: languageActiveId == 1 }"
          @click="$emit('setLanguageAvtive', 1)"
          >TH</b-button
        >
        <b-button
          :class="{ active: languageActiveId == 2 }"
          @click="$emit('setLanguageAvtive', 2)"
          >EN</b-button
        >
      </b-button-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    channelList: {
      required: false,
      type: Array,
    },
    filter: {
      required: false,
      type: Object,
    },
    tierList: {
      required: false,
      type: Array,
    },
    languageActiveId: {
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      tierSelected: [],
      channelSelected: [],
      languageSelected: 1,
      isSearch: false,
      search: "",
      languageOptions: [
        {
          text: "Radio 1",
          value: "radio1",
        },
        {
          text: "Radio 1",
          value: "radio1",
        },
      ],
    };
  },
  methods: {
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.$emit("searchIntent", this.search);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.f-size-14 {
  font-size: 14px;
}
::v-deep .dropdown-menu-right {
  min-width: 350px;
  padding: 5px;
}

.panel-intent-serach {
  background-color: #ffff;
  border: 1px solid #dbdbdb !important;
  border-radius: 5px !important;
  color: #4a4a4a;
  width: 100%;
  height: 2.5rem;
}

.panel-intent-serach > input {
  background-color: white;
}

.panel-intent-serach:focus-within {
  border-color: #5b57a5 !important;
}
@media (max-width: 767.98px) {
  ::v-deep .custom-control-inline {
    display: block;
  }
}
</style>
